import * as phone from 'phone';

import { DOMAIN_LANGUAGE } from '../constants/browser';

const customizedPhone = (
  value,
  country = DOMAIN_LANGUAGE,
  allowLandNumber = true
) =>
  phone(
    (value || '').trim(),
    value.indexOf('+') !== -1 ? '' : country,
    allowLandNumber
  );

export const toLandlineNumber = (num) => {
  const numModified = (num || '').trim();
  return numModified.indexOf('+') === 0
    ? '00' + numModified.slice(1)
    : numModified;
};

export default customizedPhone;
